<div class="container-fluid">
    <div class="row">
        <div class="col-md-3" *ngIf="showSideMenu">
            <a routerLink="/naac/dvv/criteria3/3-3-2"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>3.3.2.1 No. of Books</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li routerLinkActive="active">
                        <a  routerLink="/naac/dvv/criteria3/3-3-2/3-3-2-1/2021" (click)="checkRoute()">2021</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/naac/dvv/criteria3/3-3-2/3-3-2-1/2020" (click)="checkRoute()">2020</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/naac/dvv/criteria3/3-3-2/3-3-2-1/2019" (click)="checkRoute()">2019</a>
                    </li>
                    <li routerLinkActive="active">
                        <a  routerLink="/naac/dvv/criteria3/3-3-2/3-3-2-1/2017" (click)="checkRoute()">2017</a>
                    </li>
                </ul>
            </nav>
        </div>
        <div [ngClass]="fullWidth ? 'col-md-12' : 'col-md-9'">
            <h4 class="text-center" *ngIf="showHeading">No. of Books</h4>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>